import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TemplateGallery from './TemplateGallery';

const TemplateSelector = ({ onSelectTemplate, onCancel }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/templates', {
        headers: { 'x-auth-token': token }
      });
      setTemplates(res.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError('Failed to load templates');
      setLoading(false);
    }
  };

  const handleDeleteTemplate = (templateId) => {
    setTemplates(templates.filter(t => t._id !== templateId));
  };

  if (loading) {
    return (
      <div className="text-center py-12 text-gray-500">
        Loading templates...
      </div>
    );
  }

  return (
    <div>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-4">
          {error}
        </div>
      )}
      <TemplateGallery
        templates={templates}
        onSelect={onSelectTemplate}
        onDelete={handleDeleteTemplate}
      />
      <div className="mt-6 flex justify-center">
        <button
          type="button"
          onClick={onCancel}
          className="text-gray-500 hover:text-gray-700 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default TemplateSelector;
